import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12,
        height: 300,
    },
    iframe: {
        width: '100%',
        height: 'calc(100vh - 120px)',
        border: 'none',
        display: 'block',
    },
    iframeWrapper: {
        position: 'relative',
        width: '100%',
        height: 'calc(100vh - 120px)',
    },
    iframeOverlay: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12,
        backgroundColor: '#fff',
        zIndex: 1,
    },
    loadingText: {
        fontSize: 14,
        color: theme.palette.grey[600],
        textAlign: 'center',
    },
}));
